var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F2F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4827 12.207C22.7366 12.4737 22.7262 12.8957 22.4595 13.1495L14.7558 20.4829C14.6242 20.6081 14.4473 20.6742 14.2658 20.666C14.0844 20.6577 13.9142 20.5758 13.7945 20.4391L10.8316 17.0545C10.589 16.7775 10.617 16.3563 10.8941 16.1138C11.1711 15.8713 11.5923 15.8992 11.8348 16.1763L14.3399 19.0379L21.5402 12.1838C21.8069 11.9299 22.2289 11.9403 22.4827 12.207Z",
    fill: "#996CFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFilled);
export default __webpack_public_path__ + "static/media/check-circle-filled.2b4f8a3e816a4015b4e6f110c34002c2.svg";
export { ForwardRef as ReactComponent };